module.exports = __webpack_public_path__ + "img/icon_kefu.cc9dd91c.png";